import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import { FaDownload, FaExpand } from 'react-icons/fa6';
import GSTR1SheetModal from './tables/GSTR1SheetModal';
import RefundsSheetModal from './tables/RefundsSheetModal';
import { format } from 'date-fns'
import useCheckAuthorization from '../../hooks/checkAuthorization';
import { CRUD_PERMISSIONS } from '../../constants/staff';
import GSTR3bSheetModal from './tables/GSTR3bSheetModal';
import GSTR9SheetModal from './tables/GSTR9SheetModal';
import GSTR9CSheetModal from './tables/GSTR9cSheetModal';

const ViewSheetSummary = ({ sheetSummaryData, handleSheetSubmit, handleSheetSubmitManager, sheetType, getSheet, periodId }) => {

  const [showSheetModal, setShowSheetModal] = useState(false);
  const [viewOnlySheetData, setViewOnlySheetData] = useState(null);
  const isManager = useCheckAuthorization(CRUD_PERMISSIONS.sheet.client_manager_role);
  const closeSidebar = () => {
    document.body.classList.add('sidebar-main');
  };

  const openSidebar = () => {
    document.body.classList.remove('sidebar-main');
  };
  const handleSheetShow = (sheetData) => {
    if (sheetData) {
      setViewOnlySheetData(sheetData);
    } else {
      setViewOnlySheetData(null);
    }
    closeSidebar();
    setShowSheetModal(true);
  }
  const handleSheetClose = async () => {
    await getSheet(periodId);
    setShowSheetModal(false);
    openSidebar();
  }
  const resolvedComments = sheetSummaryData?.all_comments.filter(comment => comment.status === 4);
  return (
    <>
      <ul className="list-group list-group-flush r-list-group r-list-group-icon">
        {sheetSummaryData.sheet &&
          <li class="list-group-item">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <i className="las la-file-excel pa-text-success mx-2"></i>
                {sheetSummaryData.sheet.file_name}
              </div>
              <div className="d-flex align-items-center">
                {/* View Button with Icon */}
                <a href="#" className="p-0 mx-2 text-sm d-flex align-items-center cursor-pointer" onClick={() => handleSheetShow()}>
                  View <FaExpand className="ml-1" /> {/* Icon aligned to the right of View text */}
                </a>
                <span className="mx-1">|</span>

                {/* Download Button with Icon */}
                <a href={sheetSummaryData.sheet.url} target="_blank" className="p-0 mx-2 text-sm d-flex align-items-center">
                  Download <FaDownload className="ml-1" /> {/* Icon aligned to the right of Download text */}
                </a>
                <span className="mx-1">|</span>

                {/* Approval Status */}
                {(sheetSummaryData.sheet.preface_approval === 0 || (sheetSummaryData.sheet.preface_approval === 1 && sheetSummaryData.sheet.status === 0)) && <span className="text-sm">In Progress</span>}
                {sheetSummaryData.sheet.status === 1 && sheetSummaryData.sheet.client_approval === 1 && sheetSummaryData.sheet.preface_approval === 1 && <span className="text-sm">Approved {!isManager && `by Client`}</span>}
                {sheetSummaryData.sheet.status === 2 && sheetSummaryData.sheet.client_approval === 1 && sheetSummaryData.sheet.preface_approval === 1 && <span className="text-sm">Rejected {!isManager && `by Client`}</span>}
                {/* Staff */}
                {!isManager && (sheetSummaryData.sheet.status === 1 || sheetSummaryData.sheet.status === 2) && sheetSummaryData.sheet.client_approval === 0 && sheetSummaryData.sheet.preface_approval === 1 && sheetSummaryData.sheet.client_approval === 0 &&
                  <span className="text-sm">Waiting For Client Approval</span>
                }
                {sheetSummaryData.sheet.status === 3 && sheetSummaryData.sheet.preface_approval === 1 && sheetSummaryData.sheet.client_approval === 1 && (
                  <>
                    <Button type="button" variant="primary" size="sm" onClick={() => handleSheetSubmit(sheetSummaryData.sheet.id, 1)}>Approve</Button>
                    <span className="mx-1">|</span>
                    <Button type="button" variant="outline-primary" size="sm" onClick={() => handleSheetSubmit(sheetSummaryData.sheet.id, 2)}>Reject</Button>
                  </>
                )}
                {/* Manager */}
                {isManager &&
                  <>
                    {sheetSummaryData.sheet.preface_approval === 1 && sheetSummaryData.sheet.status === 1 && sheetSummaryData.sheet.client_approval === 0 &&
                      <>
                        <span className="text-sm">Approved by Staff</span>
                        <span className="mx-1">|</span>
                      </>
                    }
                    {sheetSummaryData.sheet.preface_approval === 1 && sheetSummaryData.sheet.status === 2 && sheetSummaryData.sheet.client_approval === 0 &&
                      <>
                        <span className="text-sm">Rejected by Staff</span>
                        <span className="mx-1">|</span>
                      </>
                    }
                    {sheetSummaryData.sheet.preface_approval === 1 && (sheetSummaryData.sheet.status === 1 || sheetSummaryData.sheet.status === 2) && sheetSummaryData.sheet.client_approval === 0 &&
                      <>
                        <Button type="button" variant="primary" size="sm" onClick={() => handleSheetSubmitManager(sheetSummaryData.sheet.id, 1)}>Confirm</Button>
                        <span className="mx-1">|</span>
                        <Button type="button" variant="outline-primary" size="sm" onClick={() => handleSheetSubmitManager(sheetSummaryData.sheet.id, 2)}>Deny</Button>
                      </>
                    }
                  </>
                }
              </div>
            </div>
            <div className="d-flex align-items-left mt-2">
              {sheetSummaryData.sheet.updated_date && <>
                <small>{format(sheetSummaryData.sheet.updated_date, 'dd-MM-yyyy')}</small>
                <small className="mx-1">|</small>
              </>}
              <small>({sheetSummaryData.all_comments.length}) Comments</small>
              <small className="mx-1">|</small>
              <small>({resolvedComments.length}) Resolved</small>
            </div>
          </li>
        }
        {sheetSummaryData?.allSheet?.map((sheetData, i) => {
          return (
            <li class="list-group-item" key={sheetData.id}>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <i className="las la-file-excel pa-text-success mx-2"></i>
                  {sheetData.file_name}
                </div>
                <div className="d-flex align-items-center">
                  {/* View Button with Icon */}
                  <a href="#" className="p-0 mx-2 text-sm d-flex align-items-center cursor-pointer" onClick={() => handleSheetShow(sheetData)}>
                    View <FaExpand className="ml-1" /> {/* Icon aligned to the right of View text */}
                  </a>
                  <span className="mx-1">|</span>

                  {/* Download Button with Icon */}
                  <a href={sheetData.url} target="_blank" className="p-0 mx-2 text-sm d-flex align-items-center">
                    Download <FaDownload className="ml-1" /> {/* Icon aligned to the right of Download text */}
                  </a>

                </div>
              </div>
              <div className="d-flex align-items-left mt-2">
                {sheetData.updated_date && <small>{format(sheetData.updated_date, 'dd-MM-yyyy')}</small>}
              </div>
            </li>
          )
        })}
      </ul>
      {sheetType === 'gstr1' && <GSTR1SheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} />}
      {sheetType === 'gstr3b' && <GSTR3bSheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} />}
      {sheetType === 'gstr9' && <GSTR9SheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} />}
      {sheetType === 'gstr9c' && <GSTR9CSheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} />}
      {sheetType === 'refunds' && <RefundsSheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} periodId={periodId} />}
    </>
  )
}

export default ViewSheetSummary
